var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { cacheHelper } from 'utils/cache-helper';
import { apiService } from './api-service';
export var LookupFieldProperty;
(function (LookupFieldProperty) {
    LookupFieldProperty["productLineCode"] = "productLineCode";
    LookupFieldProperty["discountCode"] = "discountCode";
    LookupFieldProperty["productFunctionCode"] = "productFunctionCode";
    LookupFieldProperty["weightClassCode"] = "weightClassCode";
    LookupFieldProperty["salesBrandCode"] = "brandCode";
    LookupFieldProperty["salesCategoryCode"] = "categoryCode";
    LookupFieldProperty["salesProductLineCode"] = "salesProductLineCode";
    LookupFieldProperty["salesSubCategoryCode"] = "subCategoryCode";
    LookupFieldProperty["salesTypeCode"] = "typeCode";
})(LookupFieldProperty || (LookupFieldProperty = {}));
export function lookupCodesByPrefix(field, size) {
    if (size === void 0) { size = 1; }
    return __awaiter(this, void 0, Promise, function () {
        var key, cacheRsp, queryParams, body, rsp, values, nestedAgg, codeAgg, outputRsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = "".concat(field, "_").concat(size);
                    cacheRsp = cacheHelper.getCache(key);
                    if (cacheRsp) {
                        cacheRsp;
                    }
                    queryParams = {
                        code: '',
                        description: '',
                        source: '',
                    };
                    switch (field) {
                        case LookupFieldProperty.productLineCode:
                            queryParams = { code: 'line.code', description: 'line.description.desc', source: 'line' };
                            break;
                        case LookupFieldProperty.discountCode:
                            queryParams = {
                                code: LookupFieldProperty.discountCode,
                                description: 'discountDesc',
                                source: LookupFieldProperty.discountCode,
                            };
                            break;
                        case LookupFieldProperty.productFunctionCode:
                            queryParams = {
                                code: LookupFieldProperty.productFunctionCode,
                                description: 'productFunctionDesc.desc',
                                source: LookupFieldProperty.productFunctionCode,
                            };
                            break;
                        case LookupFieldProperty.weightClassCode:
                            queryParams = {
                                code: LookupFieldProperty.weightClassCode,
                                description: 'weightClassDesc',
                                source: LookupFieldProperty.weightClassCode,
                            };
                            break;
                        case LookupFieldProperty.salesBrandCode:
                            queryParams = {
                                code: 'baseProducts.brandCode',
                                description: 'baseProducts.brandDesc',
                                source: LookupFieldProperty.salesBrandCode,
                                nestedPath: 'baseProducts',
                            };
                            break;
                        case LookupFieldProperty.salesCategoryCode:
                            queryParams = {
                                code: 'baseProducts.categoryCode',
                                description: 'baseProducts.categoryDesc',
                                source: LookupFieldProperty.salesCategoryCode,
                                nestedPath: 'baseProducts',
                            };
                            break;
                        case LookupFieldProperty.salesProductLineCode:
                            queryParams = {
                                code: 'baseProducts.productLineCode',
                                description: 'baseProducts.productLineDesc',
                                source: LookupFieldProperty.productLineCode,
                                nestedPath: 'baseProducts',
                            };
                            break;
                        case LookupFieldProperty.salesSubCategoryCode:
                            queryParams = {
                                code: 'baseProducts.subCategoryCode',
                                description: 'baseProducts.subCategoryDesc',
                                source: LookupFieldProperty.salesSubCategoryCode,
                                nestedPath: 'baseProducts',
                            };
                            break;
                        case LookupFieldProperty.salesTypeCode:
                            queryParams = {
                                code: 'baseProducts.typeCode',
                                description: 'baseProducts.typeDesc',
                                source: LookupFieldProperty.salesTypeCode,
                                nestedPath: 'baseProducts',
                            };
                            break;
                        default:
                            break;
                    }
                    body = {
                        size: size,
                        aggs: {},
                    };
                    if (queryParams.nestedPath) {
                        body.aggs = {
                            nested_baseProducts: {
                                nested: {
                                    path: queryParams.nestedPath,
                                },
                                aggs: {
                                    brandCodes: {
                                        terms: {
                                            field: queryParams.code,
                                            size: 1000,
                                        },
                                        aggs: {
                                            brandDescs: {
                                                terms: {
                                                    field: queryParams.description,
                                                    size: 10,
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        };
                    }
                    else {
                        body.aggs = {
                            code: {
                                terms: {
                                    field: queryParams.code,
                                    size: 1000,
                                },
                                aggs: {
                                    description: {
                                        terms: {
                                            field: queryParams.description,
                                            size: 10,
                                        },
                                    },
                                },
                            },
                        };
                        body.source = [queryParams.source];
                    }
                    return [4 /*yield*/, apiService.post('search?indexName=product-version', body)];
                case 1:
                    rsp = _a.sent();
                    values = [];
                    if (queryParams.nestedPath) {
                        nestedAgg = rsp.body.aggregations.nested_baseProducts;
                        if (nestedAgg) {
                            values = nestedAgg.brandCodes.buckets.map(function (el) { return ({
                                code: el.key,
                                description: el.brandDescs.buckets.map(function (bucket) { return bucket.key; }).join('; '),
                            }); });
                        }
                    }
                    else {
                        codeAgg = rsp.body.aggregations.code;
                        if (codeAgg) {
                            values = codeAgg.buckets.map(function (el) { return ({
                                code: el.key,
                                description: el.description.buckets.map(function (bucket) { return bucket.key; }).join('; '),
                            }); });
                        }
                    }
                    outputRsp = { values: values, status: rsp.status };
                    cacheHelper.setCache(key, outputRsp, 5 * 60);
                    return [2 /*return*/, outputRsp];
            }
        });
    });
}
